import { GalleryItem } from "./types";

export const galleryItems: GalleryItem[] = [
  {
    id: 2,
    title: "Natural Stone Granite",
    description:
      "Exquisite granite slabs and tiles for countertops, flooring, and wall cladding",
    image: "/api/placeholder/400/300",
    category: "Granite",
    features: ["Heat Resistant", "Scratch Proof", "Natural Beauty"],
    rating: 4.9,
    reviews: 89,
    availability: "In Stock",
    specifications: [
      "Thickness: 15-20mm",
      "Polish: High Gloss",
      "Origin: Rajasthan",
      "Finish: Polished",
    ],
    isNew: true,
  },
  {
    id: 3,
    title: "CP Fittings Collection",
    description:
      "Premium chrome-plated fittings including taps, mixers, and bathroom accessories",
    image: "/api/placeholder/400/300",
    category: "CP Fittings",
    features: ["Chrome Finish", "Leak Proof", "Long Lasting"],
    rating: 4.6,
    reviews: 234,
    availability: "In Stock",
    specifications: [
      "Material: Brass",
      "Finish: Chrome",
      "Warranty: 5 Years",
      "Flow Rate: 8-12 LPM",
    ],
    isPopular: true,
  },
  {
    id: 4,
    title: "Bath Fittings Range",
    description:
      "Complete range of modern bath fittings for contemporary bathroom designs",
    image: "/api/placeholder/400/300",
    category: "Bath Fittings",
    features: ["Modern Design", "Water Saving", "Easy Installation"],
    rating: 4.7,
    reviews: 178,
    availability: "Limited Stock",
    specifications: [
      "Set Includes: Mixer, Shower, Accessories",
      "Material: Brass",
      "Finish: Chrome/Gold",
      "Installation: Wall Mount",
    ],
  },
  {
    id: 5,
    title: "Sanitary Ware Collection",
    description:
      "Comprehensive sanitary ware including toilets, basins, and bathroom suites",
    image: "/api/placeholder/400/300",
    category: "Sanitary Ware",
    features: ["Ceramic Quality", "Space Efficient", "Hygenic Design"],
    rating: 4.5,
    reviews: 98,
    availability: "In Stock",
    specifications: [
      "Material: Vitreous China",
      "Type: One/Two Piece",
      "Water Saving: Dual Flush",
      "Installation: Floor/Wall Mount",
    ],
  },
  {
    id: 6,
    title: "Bath Accessories",
    description:
      "Stylish and functional bath accessories to complete your bathroom setup",
    image: "/api/placeholder/400/300",
    category: "Bath Accessories",
    features: ["Stylish Design", "Rust Resistant", "Easy Mounting"],
    rating: 4.4,
    reviews: 145,
    availability: "In Stock",
    specifications: [
      "Material: Stainless Steel",
      "Finish: Chrome/Matt",
      "Mounting: Wall/Glass",
      "Accessories: Multiple Options",
    ],
    isNew: true,
  },
  {
    id: 7,
    title: "Vitrified Tiles",
    description:
      "Premium vitrified tiles with superior strength and stunning visual appeal",
    image: "/api/placeholder/400/300",
    category: "Tiles",
    features: ["High Strength", "Low Absorption", "Stain Resistant"],
    rating: 4.8,
    reviews: 267,
    availability: "In Stock",
    specifications: [
      "Size: 60x60, 80x80 cm",
      "Absorption: <0.5%",
      "Finish: Polished/Matt",
      "Grade: Premium A",
    ],
    isPopular: true,
  },
  {
    id: 9,
    title: "Kitchen Sinks & Taps",
    description:
      "Durable kitchen sinks and taps designed for modern kitchen requirements",
    image: "/api/placeholder/400/300",
    category: "Kitchen Fittings",
    features: ["Food Grade Steel", "Deep Basin", "Smooth Operation"],
    rating: 4.6,
    reviews: 123,
    availability: "In Stock",
    specifications: [
      "Material: SS304",
      "Bowl: Single/Double",
      "Finish: Satin/Glossy",
      "Tap: Swivel Spout",
    ],
  },
];
